import React, { useMemo } from 'react';
import { Alert, Button, Card, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';

const { Title, Text } = Typography;

const formatMeters = (m) => {
  if (m === null || m === undefined || Number.isNaN(Number(m))) return null;
  const meters = Number(m);
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(2)} km`;
};

const GeofenceLockScreen = () => {
  const navigate = useNavigate();
  const { geofenceStatus, geofenceLoading, geofenceError, refreshGeofence, logout } = useAuth();

  const details = useMemo(() => {
    const inside = geofenceStatus?.inside === true;
    const geofenceName =
      geofenceStatus?.geofence?.name ||
      geofenceStatus?.geofence?.title ||
      geofenceStatus?.geofence?.id ||
      null;
    const distance = formatMeters(geofenceStatus?.distance_meters);
    const lat = geofenceStatus?.location?.latitude;
    const lon = geofenceStatus?.location?.longitude;

    return {
      inside,
      geofenceName,
      distance,
      lat,
      lon,
    };
  }, [geofenceStatus]);

  return (
    <div className="container" style={{ maxWidth: 820, margin: '0 auto', padding: 16 }}>
      <Card>
        <Title level={2} style={{ marginTop: 0 }}>
          Location Required
        </Title>

        <Alert
          type="error"
          showIcon
          message="App is locked outside authorized location"
          description={
            <div>
              <div>
                <Text>
                  You must be inside the approved geofence to use the app. Only the offline photo gallery is available
                  when outside.
                </Text>
              </div>
              {geofenceError && (
                <div style={{ marginTop: 8 }}>
                  <Text type="secondary">Reason: {geofenceError}</Text>
                </div>
              )}
              {!geofenceError && details.distance && (
                <div style={{ marginTop: 8 }}>
                  <Text type="secondary">Distance to nearest geofence: {details.distance}</Text>
                </div>
              )}
              {!geofenceError && details.geofenceName && (
                <div style={{ marginTop: 4 }}>
                  <Text type="secondary">Nearest geofence: {String(details.geofenceName)}</Text>
                </div>
              )}
              {!geofenceError && details.lat && details.lon && (
                <div style={{ marginTop: 4 }}>
                  <Text type="secondary">
                    Current location: {Number(details.lat).toFixed(6)}, {Number(details.lon).toFixed(6)}
                  </Text>
                </div>
              )}
            </div>
          }
          style={{ marginBottom: 16 }}
        />

        {geofenceLoading && (
          <Alert
            type="info"
            showIcon
            message="Checking location…"
            description="Please wait while we verify your location."
            style={{ marginBottom: 16 }}
          />
        )}

        <Space wrap>
          <Button type="primary" loading={geofenceLoading} onClick={() => refreshGeofence(true)}>
            Refresh Location
          </Button>
          <Button onClick={() => navigate(ROUTES.OFFLINE_PHOTOS, { replace: true })}>
            Open Offline Photo Gallery
          </Button>
          <Button onClick={() => navigate(ROUTES.SELECT_ROLE, { replace: true })}>
            Go to Role Menu
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default GeofenceLockScreen;

